import type { Messages } from '../messages.js'

/** Norwegian Bokmål. `trekk` for flips: a move, and the same in both numbers. */
export const no: Messages = {
  tag: 'no',

  readingDictionary: 'Leser ordlisten…',
  noWordList: 'Ingen ordliste for «{language}». Bygg en:  pnpm dictionary build',
  emptyWordList: 'Ordlisten for «{language}» er tom.',

  flips: 'trekk',
  score: 'poeng',
  words: 'ord',
  round: 'runde',
  ticksLeftLabel: 'Gjenstående tid i runden',
  typeAWord: 'skriv et ord',
  tapPrompt: 'trykk for å ta eller gi tilbake, så {action}',

  boardOfTiles: 'Brett med {n} brikker',
  faceDown: 'med baksiden opp',
  wildCard: 'joker',
  wildKey: 'hvilken som helst bokstav',
  letterReplaced: '{from} ble til {to}',
  letterSwap: 'BOKSTAVBYTTE!',
  spentTile: 'brukt brikke',
  hiddenWhilePaused: 'skjult under pause',
  letterInWord: '{letter}, bokstav {position} i ordet',

  completeWord: 'Lever ordet',
  completeShort: 'Lever',
  reset: 'Tøm',
  pause: 'Pause',
  resume: 'Fortsett',
  newGame: 'Nytt spill',
  paused: 'Satt på pause',
  outOfFlips: 'Tom for trekk',
  finalResult: '{score} poeng på {words} over {rounds}',
  playAgain: 'Spill igjen',
  share: 'Del',
  shareCopied: 'Kopiert.',
  shareSelect: 'Kopier dette:',

  lettersSelect: 'bokstaver velger',
  keysWild: 'tas når du skriver en bokstav ingen brikke viser',
  clearsEvery: 'fjerner alle valgte {letter}',
  undoLastLetter: 'angrer siste bokstav',
  noWordsYet: 'Ingen ord ennå.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'allerede funnet',
  reasonTooShort: 'for kort',
  reasonNotAWord: 'ikke et ord',
  reasonAllFound: 'du har alle allerede',
  noSuchLetterUp: 'ingen {letter} oppe',
  nothingUp: 'ingenting oppe',
  letterHidden: 'en bokstav skjulte seg',
  shuffled: 'stokket',
  shuffledAndBilled: 'stokket, {flips} ubrukte trekk belastet',
  tooFewLetters: 'For få bokstaver igjen',

  gameLanguage: 'språk',
  interfaceLanguage: 'grensesnitt',
  dictionarySize: '{common} vanlige av {full} ord',
  filterLanguages: 'Søk etter språk',
  noMatches: 'Ingen treff',

  nerdMode: 'ekspertmodus',
  rules: 'Regler',
  difficulty: 'vanskelighet',
  difficultyNames: { easy: 'lett', medium: 'middels', hard: 'vanskelig', insane: 'brutalt' },
  pausedNoBoard: 'Dette spillet kommer ikke på resultatlisten.',
  about: 'Om',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradisjonelt', light: 'lyst', contrast: 'høy kontrast' },
  tiles: 'brikker (N)',
  secondsPerTick: 'sekunder / takt',
  holdTicks: 'holdetakter',
  minWord: 'korteste ord',
  startingFlips: 'trekk ved start',
  wildChance: 'jokersjanse',
  replaceChance: 'sjanse for bokstavbytte',
  hideChance: 'sjanse for at en bokstav skjules',
  wordCompleteMode: 'ordet ferdig',
  wordCompleteNames: { shuffle: 'stokk', spend: 'bruk opp', keep: 'behold' },
  flipEconomy: 'trekkøkonomi',
  flipEconomyNames: {
    none: 'ingen',
    perLetter: 'per bokstav',
    fibonacci: 'fibonacci',
    overMinimum: 'over minimum',
  },
  repeatedLetterKey: 'tast for gjentatt bokstav',
  keySchemeNames: { cycle: 'sykle', advance: 'gå videre' },
  keySchemeHelp: {
    cycle:
      'A tar neste ledige A, og når alle er i ordet, fjerner den dem. ' +
      'Skift+A fjerner dem også.',
    advance: 'A tar neste ledige A. Skift+A fjerner hver A fra ordet.',
  },

  whatThatMeans: 'Hva det betyr',
  factRound: 'en runde',
  factWholeBoardUp: 'hele brettet oppe',
  factRoundCosts: 'en runde koster',
  factFlipsBuy: 'starttrekkene rekker til',
  factThisBoard: 'dette brettet',
  factBoardHadToAdmit: 'brettet måtte tillate',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, lengste {longest}',
  wordsIncludingOneOf: '{words} hvorav ett på {ceiling}',
  scorelessRounds: '{rounds} uten poeng',

  whatAWordPays: 'Hva et ord gir',
  columnLetters: 'bokstaver',
  columnCost: 'kostnad',
  columnPoints: 'poeng',
  columnFlips: 'trekk',
  columnNet: 'netto',

  canonicalRules: 'Offisielle regler for {difficulty}.',
  customRules: 'Endret fra forvalget. Poeng med egne regler blir ikke rangert.',
  applyAndStart: 'Bruk og start nytt spill',
  changesNextGame: 'Endringer gjelder fra neste spill.',
  presets: 'Forvalg:',

  start: 'Start',
  restart: 'Start på nytt',
  quit: 'Avslutt',
  quitTitle: 'Avslutte dette spillet?',
  restartTitle: 'Starte dette spillet på nytt?',
  restartConfirm: 'Start på nytt',
  quitConfirm: 'Avslutt',
  keepPlaying: 'Fortsett å spille',
  personalBest: 'Dine beste spill',
  newPersonalBest: 'Ny personlig rekord.',
  columnRank: '#',
  notRanked: 'Egne regler, så dette spillet rangeres ikke.',
  notRankedPaused: 'Klokken stoppet, så dette spillet rangeres ikke.',
  rankOfTotal: '{rank} av {total}',

  howToPlay: 'Slik spiller du',

  backToGame: 'Tilbake til spillet',
  welcomeTitle: 'Velkommen til Blinkered',
  tutorialSkip: 'Hopp over',
  tutorialNext: 'Neste',
  tutorialBack: 'Tilbake',
  tutorialStart: 'Begynn å spille',
  tutorialHideAgain: 'Ikke vis igjen',
  tutorialProgress: '{n} av {total}',
  tutorialSkipTitle: 'Hoppe over introduksjonen?',
  tutGoalTitle: 'Blinkered er et kappløp',
  tutGoalBody:
    'Du starter spillet med et fast antall trekk, og hver brikke som snus koster ett trekk. Når trekkene er brukt opp, er spillet over. Ord gir trekk, og jo lengre ordet er, desto flere trekk får du.',
  tutSpentBody:
    'Bokstaver du bruker i et ord, snus ned til neste runde. Bare et bokstavbytte endrer hvilke bokstaver som ligger på brettet.',
  tutChangeTitle: 'Bokstaver kan endre seg',
  tutSameLetters:
    'Så du et ord du ikke rakk å spille? De samme bokstavene kommer tilbake neste runde, stokket til nye plasser.',
  tutPickLetters: 'Trykk på bokstavene du vil ha, i rekkefølge, for å lage et ord.',
  tutMoreTurn: 'Brikkene fortsetter å snus mens du tenker, så en bedre bokstav kan være på vei.',
  tutTapBack:
    'Tok du feil? Trykk på den igjen for å levere den tilbake. Hvilken som helst, ikke bare den siste.',
  tutComplete: 'Trykk Ferdig når ordet er klart.',
  htBoardTitle: 'Brettet',
  htBoardBody:
    'Brikkene snus opp én om gangen, i tilfeldig rekkefølge. Av brikkene som ligger åpne lager du ord.',
  htWordsTitle: 'Ordene',
  htWordsBody:
    'Lag et ord av brikkene som ligger åpne ved å skrive eller klikke på bokstavene i rekkefølge.',
  htFlipsTitle: 'Trekkene',
  htFlipsBody:
    'Hver brikke som snus koster ett trekk. Et fullført ord legger trekk tilbake på beholdningen din, og lange ord gir mer. Når trekkene er brukt opp, er spillet over.',
  htRoundTitle: 'Runden',
  htRoundBody:
    'Når rundens siste brikke snus, ligger hele brettet åpent et øyeblikk. Så snus brikkene ned og stokkes, og en ny runde begynner.',
  htLanguagesTitle: 'Språkene',
  htLanguagesBody:
    '{n}. Hvert brett kan løses med ord folk faktisk bruker. Et uvanlig ord teller likevel, hvis ordlisten kjenner det.',
  htKeysTitle: 'Tastaturet',
  htWildTitle: 'Jokere',
  htWildBody:
    'Av og til dukker det opp en joker i stedet for en bokstav. En joker teller som hvilken som helst bokstav som lager et gyldig ord. Et ord du allerede har laget teller ikke.',
  htHideTitle: 'Bokstaver som skjuler seg',
  htHideBody:
    'På de vanskeligere nivåene kan en åpen bokstav snu seg tilbake av seg selv og komme tilbake senere i runden. Tidslinjen får et ekstra hakk for det, i rødt. Bokstaver du alt har tatt, snur seg ikke.',
  tutHideBody:
    'På de vanskeligere nivåene kan en åpen bokstav snu seg tilbake av seg selv og komme tilbake senere i runden. Bokstaver du alt har tatt, snur seg ikke.',
  htSwapTitle: 'Bokstaver som byttes',
  htSwapBody:
    'Av og til blir én bokstav byttet ut med en annen mellom rundene. Du ser hvilken bokstav som ble fjernet og hvilken som kom til.',
  htLevelsTitle: 'Nivåene',
  htLevelEasy:
    'De samme tolv bokstavene hele partiet, så du rekker å lære dem og holde en ordliste i hodet. Brikkene snus sakte, og hele brettet blir stående lenge nok til at du rekker å velge ferdig bokstavene dine.',
  htLevelMedium:
    'Nå og da byttes en bokstav, og da blir det vanskeligere å holde styr på ord du hadde tenkt å legge senere. Mindre tid til å se og mindre til å tenke.',
  htLevelHard:
    'Ord på tre bokstaver teller ikke lenger, og en bokstav byttes omtrent annenhver runde. Brettet rekker knapt å vises før det stokkes om.',
  htLevelInsane:
    'Alt på én gang, i full fart. Brettet stokkes nesten med det samme etter det siste trekket.',
  htTouchTitle: 'Berøringsskjermen',
  htTouchBody:
    'Trykk på en brikke som ligger med forsiden opp for å ta bokstaven. Trykk på en bokstav du har tatt for å gi den tilbake. Lever og Tøm ligger under brettet.',

  accountTitle: 'Kontoen din',
  menuProfile: 'Profilen min',
  menuGames: 'Spillene mine',
  menuPublicPage: 'Den offentlige siden min',
  menuSignedInAs: 'Logget inn som',
  signIn: 'Logg inn',
  signOut: 'Logg ut',
  signInTitle: 'Logg inn eller opprett konto',
  signInLead: 'En konto tar vare på spillene dine, på alle enheter du spiller på.',
  signInKeepGame: 'Logg inn for å ta vare på dette spillet, og alle etterpå.',
  continueWithApple: 'Fortsett med Apple',
  continueWithGoogle: 'Fortsett med Google',
  signInOr: 'eller',
  emailLabel: 'E-post',
  codeLabel: 'Kode',
  emailMeACode: 'Send meg en kode',
  working: 'Et øyeblikk…',
  sendNewCode: 'Send en ny kode',
  codeSent: 'Se i e-posten. Koden varer i 10 minutter.',
  notNow: 'Ikke nå',
  badEmail: 'Det ser ikke ut som en e-postadresse.',
  badCode: 'Den koden virket ikke. Koder går ut etter 10 minutter og gjelder én gang.',
  serverBusy: 'Fikk ikke kontakt med serveren. Prøv igjen om litt.',
  serverDown: 'Fikk ikke kontakt med serveren.',
  offline: 'Frakoblet',
  leaderboardTitle: 'Rangliste',
  leaderboardEmpty: 'Ingen spill på denne ranglisten ennå. Bli den første.',
  leaderboardWouldBe: 'Hvor dette spillet ville stå',
  leaderboardThisGame: 'Dette spillet',
  leaderboardRanksHere: 'Hvor dette spillet står',
  leaderboardOutside: 'Utenfor topp fem.',
  tutAccountTitle: 'Behold poengene dine',
  tutAccountBody:
    'En konto lagrer spillene dine, setter poengene dine på ranglisten og tar vare på profilen din.',
  ssoCancelled: 'Innloggingen ble avbrutt.',
  ssoExpired: 'Det tok for lang tid. Logg inn på nytt.',
  ssoNoUsername: 'Fikk ikke gjort ferdig kontoen. Prøv igjen om litt.',
  ssoFailed: 'Det gikk ikke. Prøv igjen, eller bruk e-posten din.',
  tabProfile: 'Profil',
  countryAny: 'Sier det ikke',
  findCountry: 'Søk land',
  usernameLabel: 'Brukernavn',
  bioLabel: 'Om meg',
  countryLabel: 'Land',
  bioHint: 'Ingen lenker. {left}/{max}',
  save: 'Lagre',
  saving: 'Lagrer…',
  saved: 'Lagret.',
  nameTaken: 'Noen har allerede det navnet.',
  nameTooShort: 'Litt lengre, takk.',
  nameTooLong: 'Det er for langt.',
  nameBadCharacters: 'Bare bokstaver, tall, bindestrek og understrek.',
  nameBadEdges: 'Det må begynne og slutte med en bokstav eller et tall.',
  nameMixedScripts: 'Velg ett alfabet og hold deg til det.',
  nameReserved: 'Det ligner et navn vi deler ut selv. Velg et annet.',
  nameUnusable: 'Det navnet går ikke an.',
  bioTooLong: 'Om meg rommer høyst {max} tegn.',
  bioHasLink: 'Lenker er ikke lov her.',
  bioHasControl: 'Det inneholder tegn som ikke kan stå her.',
  bioUnusable: 'Den teksten går ikke an.',
  gamesHeading: 'Spill',
  gamesEmpty: 'Ingenting her ennå. Spill du spiller innlogget, dukker opp her.',
  gamesEmptyShort: 'Ingenting her ennå.',
  gamesLoading: 'Leser spillene dine…',
  theirGamesLoading: 'Leser spillene deres…',
  profileLoading: 'Leser profilen…',
  playerNotFound: 'Det er ingen her med det navnet.',
  columnWhen: 'Når',
  columnRounds: 'runder',
  columnGame: 'Spill',
  gameLoading: 'Leser spillet…',
  gameUnreadable: 'Dette spillet kunne ikke leses.',
  gameNotRanked: 'Spilt med endrede regler, så det teller ikke.',
  detailNotKept: 'Ordene og brettene for dette spillet tas ikke vare på lenger.',
  openingBoard: 'Startbrettet',
  roundByRound: 'Runde for runde',
  roundNothing: 'ingenting funnet',
  changeReplaced: '{letter} byttet ut på plass {slot}',
  changeWildOn: '{letter} joker på plass {slot}',
  changeWildOff: '{letter} joker borte fra plass {slot}',
  keepThisGame: 'Ta vare på dette spillet',
  savedToYourGames: 'Lagret blant spillene dine.',

  reportThis: 'Rapporter',
  reportHeading: 'Rapporter dette',
  reportTheName: 'Navnet',
  reportTheBio: 'Presentasjonen',
  reportTheScore: 'Poengsummen',
  reportWhy: 'Hva er galt med det? Valgfritt.',
  reportSend: 'Send rapporten',
  reportSent: 'Takk. Noen ser på det.',
  reportSignIn: 'Logg inn for å rapportere noe.',
  reportGone: 'Det er ikke der lenger.',
  reportCancel: 'Avbryt',

  deleteAccount: 'Slett kontoen min',
  deleteAccountWhat:
    'Dette fjerner profilen din og alle spill du har beholdt, for godt. Det kan ikke angres.',
  deleteAccountAsk: 'Send meg en kode',
  deleteConfirm: 'Slett for godt',
  deleteGone: 'Kontoen din er borte. Takk for at du spilte.',
  deleteNoAddress:
    'Det finnes ingen bekreftet adresse på denne kontoen, så en sletting kan ikke sjekkes. Ta kontakt, og vi gjør det manuelt.',

  rulesetFacts: 'Ord på {letters} · ny brikke hvert {seconds}',
  plurals: {
    words: { one: '{n} ord', other: '{n} ord' },
    rounds: { one: '{n} runde', other: '{n} runder' },
    flips: { one: '{n} trekk', other: '{n} trekk' },
    ticks: { one: '{n} takt', other: '{n} takter' },
    points: { one: '{n} poeng', other: '{n} poeng' },
    minLetters: { one: 'minst {n} bokstav', other: 'minst {n} bokstaver' },
    seconds: { one: '{n} sekund', other: '{n} sekund' },
  },
}
